import script from './script'

export default {
    load(src, type) {
        return script.load(src, type)
    }
}